import * as React from "react";
import { Link } from "gatsby";
export class Header extends React.Component {
    constructor(props = {}) {
        super(props);
    }
    render() {
        return (<nav className={`flex bg-primary p-6 ${this.props.className || ""}`}>
        <div className="flex items-center flex-no-shrink text-snow mr-6">
          <Link to="/" className="font-bold text-xl text-snow no-underline hover:text-snow-lighter font-semibold">
            IME Guide
          </Link>
        </div>
        
      </nav>);
    }
}
//# sourceMappingURL=header.jsx.map